import React from 'react'
import { Skeleton, Grid } from '@mui/material';

export const HomeSkeleton = () => {

    const array = [1, 2, 3, 4, 5, 6, 7, 8];

    return (
        <>
            {array.map((num) =>
                <Grid item xs={12} sm={6} lg={3} key={num}>
                    <Skeleton variant='rectangular' width={260} height={200} animation="wave" />
                </Grid>
            )}
        </>
    )
}